import type { DayOfWeek, GetScheduleWorkingHours } from 'owa-graph-schema';
import type WorkingHoursType from 'owa-service/lib/contract/WorkingHoursType';

const dayKeyMap = new Map<DayOfWeek, number>([
    ['Sunday', 1],
    ['Monday', 2],
    ['Tuesday', 4],
    ['Wednesday', 8],
    ['Thursday', 16],
    ['Friday', 32],
    ['Saturday', 64],
]);

export default function convertGetScheduleWorkingHoursToWorkingHoursType(
    workingHours: GetScheduleWorkingHours
): WorkingHoursType {
    // The start and end time are represented as time of day in the format HH:MM:SS. Since
    // the math to convert these to minutes is relatively straightforward, and we don't need
    // to adjust for time zone, we can just use string manipulation instead of OwaDate.
    const startTime: number[] = workingHours.startTime.split(':').map(num => parseInt(num));
    const endTime: number[] = workingHours.endTime.split(':').map(num => parseInt(num));

    let workDays = 0;
    workingHours.daysOfWeek?.forEach((day: DayOfWeek) => {
        if (dayKeyMap.has(day)) {
            /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
             * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
             *	> Forbidden non-null assertion. */
            workDays += dayKeyMap.get(day)!;
        } else {
            throw new Error('Invalid day of week received');
        }
    });

    return {
        WorkHoursStartTimeInMinutes: startTime[0] * 60 + startTime[1],
        WorkHoursEndTimeInMinutes: endTime[0] * 60 + endTime[1],
        WorkDays: workDays,
        WorkingHoursTimeZoneId: workingHours.timeZone.name,
    };
}
